import Input, { type InputProps } from '@/components/base/form/input/input';
import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { Eye, EyeSlash } from '@phosphor-icons/react/dist/ssr';
import { useToggle } from '@react-hookz/web';
import { forwardRef, useRef } from 'react';
import { mergeRefs } from 'react-merge-refs';

interface PasswordInput extends InputProps {
  showPasswordVisible?: boolean;
  testId?: string;
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInput>(
  ({ showPasswordVisible, testId, ...restInput }, forwardedRef) => {
    const ref = useRef<HTMLInputElement>(null);
    const [passwordShown, togglePasswordShown] = useToggle(false);

    const handleClick = () => {
      togglePasswordShown();
      //prevent to move cursor on start
      setTimeout(() => {
        if (ref.current) {
          const end = ref.current.value.length;
          ref.current.setSelectionRange(end, end);
        }
      }, 0);
    };

    return (
      <Input
        {...restInput}
        testId={testId}
        ref={mergeRefs([forwardedRef, ref])}
        type={passwordShown ? 'text' : 'password'}
        append={
          showPasswordVisible && (
            <PhosphorIcon
              Icon={passwordShown ? EyeSlash : Eye}
              onClick={handleClick}
              variant="bold"
              className="icon-m -translate-y-1/2 absolute top-1/2 right-xs cursor-pointer"
            />
          )
        }
      />
    );
  },
);

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
